<template>
  <div>
    <sectionHeading text="Alpha Ganith" />
    <p>
      Maths Kit provides opportunity to students to understand and appreciate
      the applications of mathematics in their surroundings and real life
      situations. These activities involve both the mind and hands of the
      student working together, which facilitates cognition.
    </p>
    <p>
      Makes mathematics more interesting for students, removes math-phobia and
      help them excel in their daily math activities. Experiment and activity
      based Alpha Ganith Math Lab kit makes children to remember the math
      concepts for long term in his/her permanent Brain memory.
    </p>
    <p>
      It provides an opportunity for the students to discover through doing. In
      many of the activities, students learn to deal with problems while doing
      concrete activity, which lays down a base for more abstract thinking. The
      National Curriculum Framework for School Education (NCFSE) developed by
      NCERT emphasizes that mathematics learning should be facilitated through
      activities from the beginning. These activities may involve the use of
      materials, models, charts, pictures, games and puzzles. Helps the students
      to demonstrate abstract mathematical ideas by using concrete Models,
      Charts, Graphs, and Pictures etc. Creates interest for mathematics in
      their tender and fear ridden minds and make complicated things simple and
      easy.
    </p>
    <div class="productContainer">
      <productCard
        v-for="product in productData"
        :key="product.id"
        :product="product"
      />
    </div>
  </div>
</template>

<script>
import productCard from "@/components/common/ProductCard.vue";
import productsData from "@/assets/data/productsList.js";
export default {
  name: "alphaGanith",
  data() {
    return {
      productData: {}
    };
  },
  created() {
    this.productData = productsData;
  },
  components: {
    productCard
  }
};
</script>
<style lang="scss" scoped>
.productContainer {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
  justify-content: center;
}
</style>